import type React from 'react'
import type { JSX } from 'react'
import type { IAvatarProps } from 'atoms/Avatar'
import type { IDropdownHeaderProps } from '../DropdownHeader'

import { TextBoxColors } from 'atoms/TextBox'
import { DropdownHeader } from '../DropdownHeader'
import { DropdownHeaderJustifyContent } from '../DropdownHeader.h'

export interface IDropdownHeaderAccountProps extends Omit<
  IDropdownHeaderProps,
  'children'
> {
  title?: IAvatarProps['title']
  children?: React.ReactNode
}

export const DropdownHeaderAccount = ({
  title: _unused = '',
  justifyContent = DropdownHeaderJustifyContent.FlexEnd,
  color = TextBoxColors.TEXT_ICON_PRIMARY,
  children,
  ...rest
}: IDropdownHeaderAccountProps): JSX.Element => (
  <DropdownHeader justifyContent={justifyContent} color={color} {...rest}>
    {children}
  </DropdownHeader>
)
